import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MapGoogleService } from 'src/app/services/map-google.service';

@Component({
  selector: 'app-map-google',
  templateUrl: './map-google.component.html',
  styleUrls: ['./map-google.component.css']
})
export class MapGoogleComponent implements OnInit {


  @Input() options: google.maps.MapOptions;
  @Input() searchMap: boolean;
  @Input() zoom: number = 13;
  @Input() center;
  @Input() radius = '0px'; // border-radius style

  @Output() handleMap = new EventEmitter<google.maps.Map>();

  googleMap: google.maps.Map;
  markerSearch: { id: string, marker: google.maps.marker.AdvancedMarkerElement } = { id: '', marker: undefined };

  searchAddress = { type: 'ADDRESS', selected: [] }
  constructor(
    private _mapGoogleService: MapGoogleService,

  ) { }

  ngOnInit(): void {
    this._mapGoogleService.createGoogleMap('google-map', this.zoom, this.options, this.center).then(map => {
      this.googleMap = map;
      this.handleMap.emit(this.googleMap);
    })
  }

  // Recebe uma lista vazia caso o endereço pesquisado seja vazio ou não exista
  handleSelected(result) {
    if (this.markerSearch.marker) this.markerSearch.marker.map = null;
    if (!Array.isArray(result)) this.createMarkerSearch(result);
  }

  createMarkerSearch(result) {
    this.markerSearch.id = result?.lat + '' + result?.lng;
    this.markerSearch.marker = this._mapGoogleService.markerSearchCreate([result?.lat, result?.lng], this.googleMap);
    this.googleMap.setCenter(this.markerSearch.marker.position);
    this.googleMap.setZoom(15);
  }
}
